module.exports = __webpack_public_path__ + "static/media/tottenham.92da2293.svg";